import React from 'react';
import { Text, Image, Group } from 'react-konva';
import Node, {
  NodeProps,
} from 'components/canvas/components/nodes/components/base-node';
import NodeHeader from 'components/canvas/components/nodes/components/base-node/components/node-header';
import NodeContextMenu from 'components/canvas/components/nodes/components/base-node/components/node-context-menu';
import GlobalLinksIndicator from 'components/canvas/components/nodes/components/base-node/components/global-links-indicator';
import useNodeDimensionsOperations from 'components/canvas/hooks/use-node-dimensions-operations';
import { typography, color } from 'styles/settings';
import { SurfaceNoteNode } from 'graphql/types';
import Link from 'styles/icons/link2.svg';

interface NoteNodeProps extends NodeProps {
  node: SurfaceNoteNode;
}
// "#05f5cd"
const cornerRadius = [0, 0, 16, 0];

const style = { fill: color.brand.gold };

const styleLink = { fill: '#b4dab1' };

function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

const checkIcon = new window.Image();
checkIcon.src = Link;

function NoteNode(props: NoteNodeProps) {
  const { node } = props;

  const { getNodeDimensionsByType } = useNodeDimensionsOperations();

  const text = node.text as string;

  let isLink = isValidHttpUrl(text);

  const { width, height } = getNodeDimensionsByType(
    isLink ? 'link' : node.type,
  );
  // const { width, height } = getNodeDimensionsByType(node?.type);

  const verticalMargin = 36;
  const horizontalMargin = 40;

  return (
    <Node
      {...props}
      style={isLink ? styleLink : style}
      width={width}
      height={height}>
      {({ Rect }) => {
        return (
          <>
            <GlobalLinksIndicator node={node} x={width} />
            {React.cloneElement(Rect, { cornerRadius })}
            <NodeHeader
              x={0}
              offsetY={45}
              fill="#1C1B18"
              fontStyle="bold"
              text={node.name ?? ''}
              width={width - 30}
              isReference={Boolean(node.isReference)}
            />
            <NodeContextMenu
              width={width}
              height={height}
              node={node}
              softDelete
            />

            {!isLink && (
              <Text
                x={verticalMargin / 2}
                y={horizontalMargin / 2}
                text={text}
                fontFamily={typography.font.fontFamily}
                width={width - verticalMargin * 2.3}
                height={height - horizontalMargin}
                fontSize={16}
                lineHeight={1.5}
                wrap="char"
              />
            )}

            {isLink && (
              <Group>
                <Image
                  image={checkIcon}
                  x={verticalMargin / 2}
                  alias
                  y={horizontalMargin / 2 + 4}
                  width={40}
                  height={40}
                  onClick={(event) => {
                    window.open(text, '_blank')?.focus();
                    event.cancelBubble = true;
                  }}
                  onMouseEnter={(event) => {
                    // @ts-ignore
                    const container = event.target.getStage()?.container();
                    if (container) {
                      container.style.cursor = 'alias';
                    }
                  }}
                  onMouseLeave={(event) => {
                    // @ts-ignore
                    const container = event.target.getStage()?.container();
                    if (container) {
                      container.style.cursor = 'pointer';
                    }
                  }}
                  // onMouseLeave={(event) => {
                  //   // @ts-ignore
                  //   const container = event.target.getStage()?.container();
                  //   if (container) {
                  //     container.style.cursor = 'default';
                  //   }
                  // }}
                />

                {isLink && (
                  <Text
                    x={verticalMargin / 2 + 52}
                    y={horizontalMargin / 2}
                    text={text}
                    fontFamily={typography.font.fontFamily}
                    width={width - verticalMargin * 2 - 52}
                    height={height - horizontalMargin / 2}
                    fontSize={18}
                    lineHeight={1.3}
                    wrap="char"
                    ellipsis={true}
                  />
                )}
                {/* <Text
              x={verticalMargin / 2}
              y={horizontalMargin / 2}
              text={"OPEN"}
              fontFamily={typography.font.fontFamily}
              width={width - verticalMargin * 2.3}
              height={height - horizontalMargin}
              fontSize={16}
              lineHeight={1.5}
              wrap="char"
              // onClick={()=>{
              //    window.open(text, '_blank')?.focus();
              // }}
            />  */}
              </Group>
            )}
          </>
        );
      }}
    </Node>
  );
}

export default NoteNode;
